import { env, buildEndpointUrl } from '@/lib/env'

const base = () => env.kuro.dataBaseUrl || 'https://kuro-claw.github.io/kuro-data/kuro'

export const kuroApi = {
  overview: () => buildEndpointUrl(base(), 'overview.json'),
  activity: () => buildEndpointUrl(base(), 'activity.json'),
  about: () => buildEndpointUrl(base(), 'about.json'),
}
